








import { defineComponent } from '@vue/composition-api';
import cUsersTableHead     from '@/views/users/components/view-mode/table/components/users-table-head.component.vue';
import cUsersTableBody     from '@/views/users/components/view-mode/table/components/users-table-body.component.vue';

export default defineComponent({
  name: 'cUsersListTable',
  components: {
    cUsersTableHead,
    cUsersTableBody,
  },
});

